import { LogbookIcons, LOGBOOK_ICONS_CODEPOINTS } from "../LogbookIcons"
import { classNames, OnClickEvent } from "../Components"

export type IconType = LogbookIcons | string;

interface IconProps {
  className?: string;
  icon: IconType;
  onClick?: OnClickEvent;
  title?: string;
  text?: string;
}

export const Icons = LogbookIcons;

export function Icon({ className, icon, onClick, title, text }: IconProps) {
  return <span className={classNames([`LogbookIcon LogbookIcon-${icon}`, className, onClick && "action"])} onClick={onClick} title={title}>{text}</span>;
}

export function SetupIcons() {
  const style = document.createElement("style");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  const icons = LogbookIcons as unknown as any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: replace `any` with a concrete type
  const cps = LOGBOOK_ICONS_CODEPOINTS as unknown as any;
  for (const i in icons) {
    const n = icons[i];
    const cp = cps[n];
    style.innerHTML += `.LogbookIcon-${n}:before { content: "\\${parseInt(cp).toString(16)}"; } `;
  }

  document.head.appendChild(style);
}
